<div class="subject-facet-wrapper selenium-subject-facet">
    <div class="facet-title" (click)="onToggle()">
        <span class="toggle visible">
            <i
                class="fas"
                [ngClass]="{ 'fa-plus': isCollapsed, 'fa-minus': !isCollapsed }"
            ></i>
        </span>
        {{ title }}
        <span *ngIf="selectedFiltersCount">({{ selectedFiltersCount }})</span>
    </div>
    <div class="facet-content" [ngClass]="{ hidden: isCollapsed }">
        <app-nested-facet-nodes
            *ngFor="let facetNode of topLevel"
            [facet]="facet"
            [facetNode]="facetNode"
        ></app-nested-facet-nodes>
    </div>
</div>
